import styled from 'styled-components';
import { Colors } from '@prezi/dragon';

export default styled.button`
    border-radius: 50%;
    width: 2em;
    height: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    padding: 0;
    margin: 4px;
    transition: background-color 0.25s;

    &:hover {
        background-color: ${Colors.neutral100};
    }
`;
